// extracted by mini-css-extract-plugin
module.exports = {"form":"AuthBackdoorInput_form__2lClg"};